import { Vue, Component, Prop } from "vue-property-decorator";
import Loading from "../loading/loading";

@Component({ components: { Loading } })
export default class OverlayLoader extends Vue {
  @Prop({ default: "25px" }) spinnerDimensions!: string;
  @Prop({ default: "light" }) backgroundType!: string;
}
